import axios from 'axios';
import { router as enRouter } from '@/router/en/index';
import { router as ruRouter } from '@/router/ru/index';
import config from '@/config';

export const createHttpClient = () => {
  const fullDomain = window.location.hostname;
  const domain = fullDomain.split('.').slice(-2).join('.');

  const language = config.domains[domain] || 'en';

  const token = window.localStorage.getItem('token');
  const client = axios.create({
    baseURL: config.apiURL[language],
    headers: {
      Accept: 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
  });

  const getRouterByDomain = () => (language === 'ru' ? ruRouter : enRouter);

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      const router = getRouterByDomain();

      if (error.response && error.response.status === 500) {
        router.push({ name: 'server-error' });
      }
      if (error.response && error.response.status === 404) {
        router.push({ name: 'not-found' });
      }

      throw error;
    },
  );

  return client;
};

export const httpClient = createHttpClient();
